import styled from "@emotion/styled";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { FileDropzone } from "../../controls";

const Container = styled.div`
  & .file-container {
    padding: 8px;
  }
`;

export const JsonFileDropzone = withJsonFormsControlProps(({ data, path, label, handleChange }) => (
  <Container>
    <div>{label}</div>
    <FileDropzone
      onFileSelected={async (file) => handleChange(path, await file.text())}
      onFileDeselected={async () => handleChange(path, undefined)}
      onFileSelectionCancelled={async () => {}}
      mimeType="audio/*,image/*,video/*,.txt,.glb"
    >
      {data && <span>{data}</span>}
    </FileDropzone>
  </Container>
));
